import Swal from "sweetalert2";

export const AppSwal  = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: true
});
